import { QuiltData } from '../components/QuiltPlanner';

// Mattress sizes by region
const MATTRESS_SIZES = {
  "US & Canada": {
    "Crib": { width: 28, length: 52, cm: [71, 132] },
    "Twin": { width: 38, length: 75, cm: [97, 191] },
    "Full/Double": { width: 54, length: 75, cm: [137, 191] },
    "Queen": { width: 60, length: 80, cm: [152, 203] },
    "King": { width: 76, length: 80, cm: [193, 203] }
  },
  "UK & Ireland": {
    "Cot/Crib": { width: 24, length: 47, cm: [60, 120] },
    "Single": { width: 35, length: 75, cm: [90, 190] },
    "Double": { width: 53, length: 75, cm: [135, 190] },
    "King": { width: 59, length: 79, cm: [150, 200] },
    "Super King": { width: 71, length: 79, cm: [180, 200] }
  },
  "Europe": {
    "Cot/Crib": { width: 27, length: 52, cm: [70, 140] },
    "Single": { width: 35, length: 79, cm: [90, 200] },
    "Double": { width: 55, length: 79, cm: [140, 200] },
    "Queen": { width: 63, length: 79, cm: [160, 200] },
    "King": { width: 71, length: 79, cm: [180, 200] }
  },
  "Australia & NZ": {
    "Cot/Crib": { width: 27, length: 52, cm: [69, 130] },
    "Single": { width: 36, length: 74, cm: [92, 188] },
    "King Single": { width: 42, length: 80, cm: [107, 203] },
    "Double": { width: 54, length: 74, cm: [138, 188] },
    "Queen": { width: 60, length: 80, cm: [153, 203] },
    "King": { width: 72, length: 80, cm: [183, 203] }
  },
  "Japan": {
    "Crib": { width: 27, length: 47, cm: [70, 120] },
    "Single": { width: 38, length: 77, cm: [97, 195] },
    "Semi-Double": { width: 47, length: 77, cm: [120, 195] },
    "Double": { width: 55, length: 77, cm: [140, 195] },
    "Queen": { width: 60, length: 77, cm: [152, 195] },
    "King": { width: 71, length: 77, cm: [180, 195] }
  },
  "Singapore & Malaysia": {
    "Cot/Crib": { width: 28, length: 52, cm: [71, 132] },
    "Single": { width: 36, length: 75, cm: [91, 190] },
    "Super Single": { width: 42, length: 75, cm: [107, 190] },
    "Queen": { width: 60, length: 75, cm: [152, 190] },
    "King": { width: 72, length: 75, cm: [183, 190] }
  },
  "Hong Kong": {
    "Cot/Crib": { width: 27, length: 47, cm: [70, 120] },
    "Single": { width: 36, length: 72, cm: [91, 183] },
    "Double": { width: 48, length: 72, cm: [122, 183] },
    "Queen": { width: 60, length: 75, cm: [152, 190] },
    "King": { width: 72, length: 78, cm: [183, 198] }
  },
  "China": {
    "Crib": { width: 28, length: 52, cm: [70, 133] },
    "Single": { width: 47, length: 79, cm: [120, 200] },
    "Queen": { width: 59, length: 79, cm: [150, 200] },
    "King": { width: 71, length: 79, cm: [180, 200] }
  },
  "India": {
    "Crib": { width: 27, length: 52, cm: [70, 132] },
    "Single": { width: 36, length: 75, cm: [91, 191] },
    "Double": { width: 48, length: 75, cm: [122, 191] },
    "Queen": { width: 60, length: 75, cm: [152, 191] },
    "King": { width: 72, length: 75, cm: [183, 191] }
  },
  "South Africa": {
    "Cot/Crib": { width: 27, length: 52, cm: [70, 132] },
    "Single": { width: 36, length: 74, cm: [91, 188] },
    "Three-Quarter": { width: 42, length: 74, cm: [107, 188] },
    "Double": { width: 54, length: 74, cm: [137, 188] },
    "Queen": { width: 60, length: 74, cm: [152, 188] },
    "King": { width: 72, length: 74, cm: [183, 188] }
  },
  "Brazil": {
    "Berço (Crib)": { width: 27, length: 52, cm: [70, 130] },
    "Solteiro (Single)": { width: 35, length: 74, cm: [88, 188] },
    "Casal (Double)": { width: 54, length: 74, cm: [138, 188] },
    "Queen": { width: 62, length: 78, cm: [158, 198] },
    "King": { width: 76, length: 80, cm: [193, 203] }
  }
};

// Standard bed dimensions in inches (fallback for older data)
const BED_DIMENSIONS = {
  'crib': { width: 28, height: 52 },
  'twin': { width: 39, height: 75 },
  'full-double': { width: 54, height: 75 },
  'queen': { width: 60, height: 80 },
  'king': { width: 76, height: 80 },
};

// Standard throw dimensions
const THROW_DIMENSIONS = {
  'small': { width: 40, height: 50 },
  'standard': { width: 50, height: 60 },
  'large': { width: 60, height: 70 },
  'oversized': { width: 70, height: 80 },
};

// Batting sizes with links
const BATTING_SIZES = [
  { name: 'Craft', width: 46, height: 36, link: 'https://www.missouriquiltco.com/collections/brand-quilters-dream/size-craft' },
  { name: 'Crib', width: 46, height: 60, link: 'https://www.missouriquiltco.com/collections/brand-quilters-dream/size-crib' },
  { name: 'Throw', width: 60, height: 60, link: 'https://www.missouriquiltco.com/collections/brand-quilters-dream/size-throw-lap' },
  { name: 'Twin', width: 93, height: 72, link: 'https://www.missouriquiltco.com/collections/brand-quilters-dream/size-twin' },
  { name: 'Full/double', width: 96, height: 93, link: 'https://www.missouriquiltco.com/collections/brand-quilters-dream/size-full' },
  { name: 'Queen', width: 108, height: 93, link: 'https://www.missouriquiltco.com/collections/brand-quilters-dream/size-queen' },
  { name: 'King', width: 122, height: 120, link: 'https://www.missouriquiltco.com/collections/brand-quilters-dream/size-king' },
];

export interface QuiltCalculationResults {
  quiltSize?: { width: number; height: number };
  blocksAcross: number;
  blocksDown: number;
  totalBlocks: number;
  unfinshedBlockSize?: { width: number; height: number };
  finishedBlockSize?: { width: number; height: number };
  sashingSize?: number;
  borderSize: number;
  borderSizes: number[];
  blocksFabric?: { 
    yards: string; 
    meters: string;
    fatQuarters?: string;
    packs?: string;
    strips: string; 
    stripWidth: string; 
  };
  sashing?: {
    fabric?: { yards: string; meters: string; fatQuarters?: string; packs?: string; strips: string; stripWidth: string; };
    cornerstone?: { yards: string; meters: string; fatQuarters?: string; packs?: string; strips: string; stripWidth: string; };
    rows: { count: number; size: { width: number; height: number; }; };
    columns: { count: number; size: { width: number; height: number; }; };
    cornerstones?: { count: number; size: { width: number; height: number; }; };
    sewingOrder: string[];
  };
  border?: {
    fabric: { yards: string; meters: string; fatQuarters?: string; packs?: string; strips: string; stripWidth: string; };
    rows: { count: number; size: { width: number; height: number; }; };
    columns: { count: number; size: { width: number; height: number; }; };
    sewingOrder: string[];
  };
  borders?: Array<{
    borderNumber: number;
    ordinal: string;
    fabric: { yards: string; meters: string; fatQuarters?: string; packs?: string; strips: string; stripWidth: string; };
    rows: { count: number; size: { width: number; height: number; }; };
    columns: { count: number; size: { width: number; height: number; }; };
    sewingOrder: string[];
  }>;
  backing: {
    fabric: { yards: string; meters: string; fatQuarters?: string; packs?: string; panels: string; panelLength: string; orientation?: string; };
    size: { width: number; height: number; };
  };
  batting: {
    sizeName: string;
    link: string;
    multiple?: boolean;
    offTheBolt?: boolean;
  };
  binding?: {
    fabric?: { yards: string; meters: string; fatQuarters?: string; packs?: string; strips: string; stripWidth: string; };
    size?: { length: number; };
    tapeNeeded?: string;
  };
  estimatedCost?: number;
}

export class QuiltCalculations {
  constructor(private data: QuiltData) {}

  // Helper to get pieces per pack for pre-cut packs
  private getPiecesPerPack(cutType: string, element: string = ''): number {
    const packQuantity = this.data.packQuantity?.[element as keyof typeof this.data.packQuantity];
    
    if (cutType === 'mini-charm' || cutType === 'charm-pack') {
      return 42;
    } else if (cutType === 'jelly-roll' || cutType === 'honey-bun') {
      return packQuantity || 40;
    } else if (cutType === 'layer-cake') {
      return packQuantity || 42;
    } else if (cutType === 'fat-quarters') {
      return packQuantity || 20;
    }
    return 0;
  }

  // Helper to calculate proportional cost for pre-cut packs
  private calculateProportionalPackCost(
    cutType: string,
    element: string,
    piecesNeeded: number,
    packPrice: number
  ): number {
    // Validate inputs
    if (!packPrice || isNaN(packPrice) || packPrice <= 0) return 0;
    if (!piecesNeeded || isNaN(piecesNeeded) || piecesNeeded <= 0) return 0;
    
    const piecesPerPack = this.getPiecesPerPack(cutType, element);
    if (piecesPerPack === 0) return packPrice;
    
    // Calculate the proportion of the pack being used
    const proportionUsed = piecesNeeded / piecesPerPack;
    
    // Return the proportional cost
    const cost = proportionUsed * packPrice;
    return isNaN(cost) ? 0 : cost;
  }

  private calculateFatQuarters(yardage: number, isMetric: boolean = false): number {
    // Standard fat quarters: 4 fat quarters per yard or per meter
    return Math.ceil(yardage * 4);
  }

  private calculateFatQuartersForBlocks(totalBlocks: number, blockWidth: number, blockHeight: number, isMetric: boolean = false): number {
    if (isMetric) {
      // Metric fat quarters: 50cm x 55cm
      // Convert block size from inches to cm (1 inch = 2.54 cm)
      const blockWidthCm = blockWidth * 2.54;
      const blockHeightCm = blockHeight * 2.54;
      
      // How many blocks fit in one fat quarter
      const blocksPerFQ = Math.floor(50 / blockWidthCm) * Math.floor(55 / blockHeightCm);
      
      if (blocksPerFQ === 0) return totalBlocks; // If blocks don't fit, need one FQ per block
      return Math.ceil(totalBlocks / blocksPerFQ);
    } else {
      // Imperial fat quarters: 18" x 22"
      // How many blocks fit in one fat quarter
      const blocksPerFQ = Math.floor(18 / blockWidth) * Math.floor(22 / blockHeight);
      
      if (blocksPerFQ === 0) return totalBlocks; // If blocks don't fit, need one FQ per block
      return Math.ceil(totalBlocks / blocksPerFQ);
    }
  }

  private calculatePreCutPacks(
    element: string,
    cutType: string,
    totalPieces: number,
    pieceWidth: number,
    pieceHeight: number,
    stripsNeeded: number,
    isMetric: boolean = false
  ): string {
    if (cutType === 'mini-charm' || cutType === 'charm-pack') {
      const squaresPerPack = 42;
      return Math.ceil(totalPieces / squaresPerPack).toString();
    } else if (cutType === 'jelly-roll' || cutType === 'honey-bun') {
      const stripsPerPack = this.data.packQuantity?.[element as keyof typeof this.data.packQuantity] || 40;
      return Math.ceil(stripsNeeded / stripsPerPack).toString();
    } else if (cutType === 'layer-cake') {
      const squaresPerPack = this.data.packQuantity?.[element as keyof typeof this.data.packQuantity] || 42;
      return Math.ceil(totalPieces / squaresPerPack).toString();
    } else if (cutType === 'fat-quarters') {
      const quartersPerPack = this.data.packQuantity?.[element as keyof typeof this.data.packQuantity] || 20;
      // Fat quarter is 18" x 21" (or 45cm x 53cm)
      const fqArea = isMetric ? 45 * 53 : 18 * 21;
      const pieceArea = pieceWidth * pieceHeight;
      const piecesPerFq = Math.floor(fqArea / pieceArea);
      const fqsNeeded = piecesPerFq > 0 ? Math.ceil(totalPieces / piecesPerFq) : totalPieces;
      return Math.ceil(fqsNeeded / quartersPerPack).toString();
    }
    return '0';
  }

  private calculateFatQuartersForSashing(totalPieces: number, pieceWidth: number, isMetric: boolean = false): number {
    if (isMetric) {
      // Metric fat quarters: 50cm x 55cm
      const pieceWidthCm = pieceWidth * 2.54;
      const piecesPerFQ = Math.floor(50 / pieceWidthCm) * Math.floor(55 / pieceWidthCm);
      if (piecesPerFQ === 0) return totalPieces;
      return Math.ceil(totalPieces / piecesPerFQ);
    } else {
      // Imperial fat quarters: 18" x 22"
      const piecesPerFQ = Math.floor(18 / pieceWidth) * Math.floor(22 / pieceWidth);
      if (piecesPerFQ === 0) return totalPieces;
      return Math.ceil(totalPieces / piecesPerFQ);
    }
  }

  private calculateFatQuartersForBorder(quiltSize: { width: number; height: number }, borderSize: number, isMetric: boolean = false): number {
    // For borders, fat quarters are usually not practical for large quilts
    // Return a conservative estimate based on yardage conversion
    const borderLength = (quiltSize.width + quiltSize.height) * 2 + borderSize * 8; // Rough estimate
    const yards = borderLength / 36;
    return Math.ceil(yards * 4);
  }

  private calculateFatQuartersForBacking(quiltSize: { width: number; height: number }, isMetric: boolean = false): number {
    // Backing from fat quarters is impractical for most quilts
    // Return a conservative estimate based on area
    const backingArea = (quiltSize.width + 4) * (quiltSize.height + 4);
    const fqArea = isMetric ? (19.7 * 21.7) : (18 * 22);
    return Math.ceil(backingArea / fqArea);
  }

  private calculateFatQuartersForBinding(quiltSize: { width: number; height: number }, bindingWidth: number, isMetric: boolean = false): number {
    // Calculate perimeter and convert to fat quarters needed
    const perimeter = (quiltSize.width + quiltSize.height) * 2 + 12;
    const stripLength = isMetric ? 50 : 18; // Usable length from fat quarter
    const stripsNeeded = Math.ceil(perimeter / stripLength);
    const fqArea = isMetric ? (19.7 * 21.7) : (18 * 22);
    const stripArea = stripLength * (bindingWidth + 0.5);
    const stripsPerFQ = Math.floor(fqArea / stripArea);
    if (stripsPerFQ === 0) return stripsNeeded;
    return Math.ceil(stripsNeeded / stripsPerFQ);
  }

  calculate(): QuiltCalculationResults {
    const quiltSize = this.calculateQuiltSize();
    const blockSize = this.getFinishedBlockSize();
    const sashingSize = this.getSashingSize();
    const borderSize = this.getBorderSize();
    const seamAllowance = this.getSeamAllowance();

    if (!quiltSize || !blockSize) {
      return {
        blocksAcross: 0,
        blocksDown: 0,
        totalBlocks: 0,
        borderSize: 0,
        borderSizes: [],
        backing: this.calculateBacking({ width: 50, height: 60 }),
        batting: this.calculateBatting({ width: 50, height: 60 }),
      };
    }

    // Calculate available space for blocks (after borders)
    const availableWidth = quiltSize.width - (borderSize * 2);
    const availableHeight = quiltSize.height - (borderSize * 2);

    // Calculate blocks needed
    const blockAndSashingSize = blockSize.width + sashingSize;
    const blocksAcross = Math.floor((availableWidth + sashingSize) / blockAndSashingSize);
    const blocksDown = Math.floor((availableHeight + sashingSize) / blockAndSashingSize);
    const totalBlocks = blocksAcross * blocksDown;

    // Calculate unfinished block size (add seam allowance)
    const unfinshedBlockSize = {
      width: blockSize.width + (seamAllowance * 2),
      height: blockSize.height + (seamAllowance * 2),
    };

    // Calculate fabric requirements
    const blocksFabric = this.calculateBlocksFabric(totalBlocks, unfinshedBlockSize);
    const sashing = this.calculateSashing(blocksAcross, blocksDown, blockSize, sashingSize, seamAllowance);
    const borders = this.calculateMultipleBorders(quiltSize, borderSize, seamAllowance);
    const backing = this.calculateBacking(quiltSize);
    const batting = this.calculateBatting(quiltSize);
    const binding = this.calculateBinding(quiltSize);
    const estimatedCost = this.calculateEstimatedCost();

    return {
      quiltSize,
      blocksAcross,
      blocksDown,
      totalBlocks,
      unfinshedBlockSize,
      finishedBlockSize: blockSize,
      sashingSize,
      borderSize: this.getBorderSize(),
      borderSizes: this.getBorderSizes(),
      blocksFabric,
      sashing,
      borders,
      backing,
      batting,
      binding,
      estimatedCost,
    };
  }

  private calculateQuiltSize(): { width: number; height: number } | null {
    if (this.data.purpose === 'bed-cover') {
      if (!this.data.bedSize) return null;
      
      // Handle custom bed size - no overhang needed, dimensions are the final quilt size
      if (this.data.bedSize === 'custom') {
        return this.data.customBedSize || { width: 60, height: 80 };
      }
      
      // Get mattress dimensions from selected country or fallback to US & Canada
      const selectedCountry = this.data.country || "US & Canada";
      const countryBedSizes = MATTRESS_SIZES[selectedCountry as keyof typeof MATTRESS_SIZES];
      
      let baseDimensions: { width: number; height: number } | null = null;
      
      if (countryBedSizes) {
        // Find the bed size by matching the key (handling different formats)
        const bedSizeKey = Object.keys(countryBedSizes).find(key => 
          key.toLowerCase().replace(/[\/\s]/g, '-') === this.data.bedSize
        );
        
        if (bedSizeKey) {
          const mattressData = countryBedSizes[bedSizeKey as keyof typeof countryBedSizes];
          baseDimensions = { width: mattressData.width, height: mattressData.length };
        }
      }
      
      // Fallback to old BED_DIMENSIONS if not found in country data
      if (!baseDimensions) {
        baseDimensions = BED_DIMENSIONS[this.data.bedSize as keyof typeof BED_DIMENSIONS];
      }
      
      if (!baseDimensions) return null;

      // Ensure each overhang field has a number (0, 10, 12, etc.)
      // Using ?? preserves valid 0's and only falls back if null/undefined.
      const oh = {
        sides: this.data.mattressOverhang?.sides ?? 10,
        foot:  this.data.mattressOverhang?.foot  ?? 10,
        head:  this.data.mattressOverhang?.head  ?? 0,
      };
      
      return {
        width:  baseDimensions.width  + (oh.sides * 2),
        height: baseDimensions.height +  oh.foot + oh.head,
      };

    } else if (this.data.purpose === 'throw-blanket') {
      if (this.data.throwSize === 'custom') {
        return this.data.customThrowSize || { width: 50, height: 60 };
      } else if (this.data.throwSize) {
        return THROW_DIMENSIONS[this.data.throwSize];
      }
    }
    
    return null;
  }

  private getFinishedBlockSize(): { width: number; height: number } | null {
    if (!this.data.blockSize) return { width: 9, height: 9 }; // Default
    
    if (this.data.blockSize === 'custom') {
      return this.data.customBlockSize || { width: 9, height: 9 };
    }
    
    const sizeMap = {
      '3x3': { width: 3, height: 3 },
      '6x6': { width: 6, height: 6 },
      '9x9': { width: 9, height: 9 },
      '10x10': { width: 10, height: 10 },
      '12x12': { width: 12, height: 12 },
    };
    
    return sizeMap[this.data.blockSize] || { width: 9, height: 9 };
  }

  private getSashingSize(): number {
    if (!this.data.sashing || this.data.sashing === 'none') return 0;
    
    if (this.data.sashing === 'custom') {
      return this.data.customSashing || 0;
    }
    
    return parseFloat(this.data.sashing);
  }

  private getBorderSizes(): number[] {
    if (!this.data.borders || this.data.borders.length === 0) return [];
    
    return this.data.borders
      .filter(border => border.size && border.size !== 'none')
      .map(border => {
        if (border.size === 'custom') {
          return border.customSize || 0;
        }
        return parseFloat(border.size);
      });
  }

  private getBorderSize(): number {
    if (!this.data.borders || this.data.borders.length === 0) return 0;
    
    // Calculate total border size (sum of all borders)
    return this.data.borders.reduce((total, border) => {
      if (!border.size || border.size === 'none') return total;
      
      if (border.size === 'custom') {
        return total + (border.customSize || 0);
      }
      
      return total + parseFloat(border.size);
    }, 0);
  }

  private getSeamAllowance(): number {
    if (this.data.seam === 'custom') {
      return this.data.customSeam || 0.25;
    }
    return 0.25; // Default 0.25"
  }

  private calculateBlocksFabric(totalBlocks: number, blockSize: { width: number; height: number }) {
    const fabricWidth = this.data.fabricWidth?.blocks || 44;
    const useFatQuarters = this.data.fatQuarters?.blocks || false;
    const cutType = this.data.fabricCutType?.blocks || 'off-the-bolt';
    
    // Simplified calculation - assumes cutting squares
    const blocksPerStrip = Math.floor(fabricWidth / blockSize.width);
    const stripsNeeded = Math.ceil(totalBlocks / blocksPerStrip);
    const totalLength = stripsNeeded * blockSize.height;
    const yards = Math.ceil((totalLength / 36) * 4) / 4; // Round to nearest 0.25 yard
    
    const result: any = {
      yards: this.formatFraction(yards),
      meters: this.formatFraction(yards * 0.9144), // Convert yards to meters
      strips: this.formatNumber(stripsNeeded),
      stripWidth: this.formatFraction(blockSize.height),
    };

    if (useFatQuarters) {
      const isMetric = this.data.measurementSystem === 'meters';
      result.fatQuarters = this.calculateFatQuartersForBlocks(totalBlocks, blockSize.width, blockSize.height, isMetric).toString();
    }

    // Calculate packs for precut fabrics
    const elementMeasurement = this.data.measurementSystem === 'mix'
      ? (this.data.elementMeasurementSystem?.blocks || 'yards')
      : (this.data.measurementSystem || 'yards');
    const isMetric = elementMeasurement === 'meters';
    
    if (['mini-charm', 'charm-pack', 'jelly-roll', 'layer-cake', 'fat-quarters', 'honey-bun'].includes(cutType)) {
      result.packs = this.calculatePreCutPacks(
        'blocks',
        cutType,
        totalBlocks,
        blockSize.width,
        blockSize.height,
        stripsNeeded,
        isMetric
      );
    }

    return result;
  }

  private calculateEstimatedCost(): number {
    const quiltSize = this.calculateQuiltSize();
    if (!quiltSize) return 0;

    const blockSize = this.getFinishedBlockSize();
    const sashingSize = this.getSashingSize();
    const borderSize = this.getBorderSize();
    const seamAllowance = this.getSeamAllowance();

    if (!blockSize) return 0;

    // Calculate blocks needed
    const availableWidth = quiltSize.width - (borderSize * 2);
    const availableHeight = quiltSize.height - (borderSize * 2);
    const blockAndSashingSize = blockSize.width + sashingSize;
    const blocksAcross = Math.floor((availableWidth + sashingSize) / blockAndSashingSize);
    const blocksDown = Math.floor((availableHeight + sashingSize) / blockAndSashingSize);
    const totalBlocks = blocksAcross * blocksDown;

    const unfinshedBlockSize = {
      width: blockSize.width + (seamAllowance * 2),
      height: blockSize.height + (seamAllowance * 2),
    };

    // Calculate fabric yards needed
    const blocksFabric = this.calculateBlocksFabric(totalBlocks, unfinshedBlockSize);
    const backing = this.calculateBacking(quiltSize);
    
    // Default fabric costs per yard if not specified
    const costs = this.data.fabricCost || {
      blocks: 10,
      sashing: 10,
      cornerstones: 10,
      border: 10,
      backing: 8,
      binding: 8
    };

    let totalCost = 0;

    // Blocks fabric cost
    if (blocksFabric) {
      const cutType = this.data.fabricCutType?.blocks || 'off-the-bolt';
      if (cutType === 'mini-charm' || cutType === 'charm-pack' || cutType === 'jelly-roll' || cutType === 'layer-cake' || cutType === 'fat-quarters' || cutType === 'honey-bun') {
        // For packs, calculate proportional cost based on pieces used
        let piecesNeeded = 0;
        if (cutType === 'jelly-roll' || cutType === 'honey-bun') {
          const strips = blocksFabric.strips ? parseFloat(blocksFabric.strips) : 0;
          piecesNeeded = isNaN(strips) ? 0 : strips;
        } else {
          piecesNeeded = totalBlocks; // For squares/fat quarters
        }
        const cost = this.calculateProportionalPackCost(cutType, 'blocks', piecesNeeded, costs.blocks);
        if (!isNaN(cost)) totalCost += cost;
      } else {
        // For yardage, use yards
        const blocksYards = parseFloat(blocksFabric.yards);
        if (!isNaN(blocksYards)) totalCost += blocksYards * costs.blocks;
      }
    }

    // Sashing fabric cost
    if (this.data.sashing && this.data.sashing !== 'none') {
      const sashing = this.calculateSashing(blocksAcross, blocksDown, blockSize, sashingSize, seamAllowance);
      if (sashing?.fabric) {
        const sashingCutType = this.data.fabricCutType?.sashing || 'off-the-bolt';
        if (sashingCutType === 'mini-charm' || sashingCutType === 'charm-pack' || sashingCutType === 'jelly-roll' || sashingCutType === 'layer-cake' || sashingCutType === 'fat-quarters' || sashingCutType === 'honey-bun') {
          // For packs, calculate proportional cost based on pieces used
          let piecesNeeded = 0;
          if (sashingCutType === 'jelly-roll' || sashingCutType === 'honey-bun') {
            const strips = sashing.fabric.strips ? parseFloat(sashing.fabric.strips) : 0;
            piecesNeeded = isNaN(strips) ? 0 : strips;
          } else {
            piecesNeeded = sashing.rows.count + sashing.columns.count;
          }
          const cost = this.calculateProportionalPackCost(sashingCutType, 'sashing', piecesNeeded, costs.sashing);
          if (!isNaN(cost)) totalCost += cost;
        } else {
          const sashingYards = parseFloat(sashing.fabric.yards);
          if (!isNaN(sashingYards)) totalCost += sashingYards * costs.sashing;
        }
      }
      
      // Cornerstone fabric cost
      if (this.data.cornerstones && sashing?.cornerstone) {
        const cornerstoneCutType = this.data.fabricCutType?.cornerstones || 'off-the-bolt';
        if (cornerstoneCutType === 'mini-charm' || cornerstoneCutType === 'charm-pack' || cornerstoneCutType === 'jelly-roll' || cornerstoneCutType === 'layer-cake' || cornerstoneCutType === 'fat-quarters' || cornerstoneCutType === 'honey-bun') {
          // For packs, calculate proportional cost based on pieces used
          let piecesNeeded = 0;
          if (cornerstoneCutType === 'jelly-roll' || cornerstoneCutType === 'honey-bun') {
            const strips = sashing.cornerstone.strips ? parseFloat(sashing.cornerstone.strips) : 0;
            piecesNeeded = isNaN(strips) ? 0 : strips;
          } else {
            piecesNeeded = sashing.cornerstones ? sashing.cornerstones.count : 0;
          }
          const cost = this.calculateProportionalPackCost(cornerstoneCutType, 'cornerstones', piecesNeeded, costs.cornerstones);
          if (!isNaN(cost)) totalCost += cost;
        } else {
          const cornerstoneYards = parseFloat(sashing.cornerstone.yards);
          if (!isNaN(cornerstoneYards)) totalCost += cornerstoneYards * costs.cornerstones;
        }
      }
    }

    // Borders fabric cost
    if (this.data.borders && this.data.borders.some(border => border.size && border.size !== 'none')) {
      const borders = this.calculateMultipleBorders(quiltSize, borderSize, seamAllowance);
      if (borders && borders.length > 0) {
        borders.forEach((border, index) => {
          if (border?.fabric) {
            const borderElement = `border${index + 1}`;
            const borderCutType = this.data.fabricCutType?.[borderElement as keyof typeof this.data.fabricCutType] || 'off-the-bolt';
            const borderCost = this.data.fabricCost?.[borderElement as keyof typeof this.data.fabricCost] || costs.border;
            
            if (borderCutType === 'mini-charm' || borderCutType === 'charm-pack' || borderCutType === 'jelly-roll' || borderCutType === 'layer-cake' || borderCutType === 'fat-quarters' || borderCutType === 'honey-bun') {
              // For packs, calculate proportional cost based on pieces used
              let piecesNeeded = 0;
              if (borderCutType === 'jelly-roll' || borderCutType === 'honey-bun') {
                const strips = border.fabric.strips ? parseFloat(border.fabric.strips) : 0;
                piecesNeeded = isNaN(strips) ? 0 : strips;
              } else {
                piecesNeeded = (border.rows?.count || 0) + (border.columns?.count || 0);
              }
              const cost = this.calculateProportionalPackCost(borderCutType, borderElement, piecesNeeded, borderCost);
              if (!isNaN(cost)) totalCost += cost;
            } else {
              const borderYards = parseFloat(border.fabric.yards);
              if (!isNaN(borderYards)) totalCost += borderYards * borderCost;
            }
          }
        });
      }
    }

    // Backing fabric cost
    const backingCutType = this.data.fabricCutType?.backing || 'off-the-bolt';
    if (backingCutType === 'mini-charm' || backingCutType === 'charm-pack' || backingCutType === 'jelly-roll' || backingCutType === 'layer-cake' || backingCutType === 'fat-quarters' || backingCutType === 'honey-bun') {
      // For packs, calculate proportional cost based on pieces used
      let piecesNeeded = 0;
      if (backingCutType === 'jelly-roll' || backingCutType === 'honey-bun') {
        const strips = backing.fabric.strips ? parseFloat(backing.fabric.strips) : 0;
        piecesNeeded = isNaN(strips) ? 0 : strips;
      } else {
        // For backing, estimate based on panels
        piecesNeeded = backing.fabric.panels || 1;
      }
      const cost = this.calculateProportionalPackCost(backingCutType, 'backing', piecesNeeded, costs.backing);
      if (!isNaN(cost)) totalCost += cost;
    } else {
      const backingYards = parseFloat(backing.fabric.yards);
      if (!isNaN(backingYards)) totalCost += backingYards * costs.backing;
    }

    // Batting cost (if off-the-bolt)
    if (this.data.battingType === 'off-the-bolt') {
      const batting = this.calculateBatting(quiltSize);
      if (batting?.sizeName && batting.sizeName.includes('yards')) {
        const yardsMatch = batting.sizeName.match(/(\d+\.?\d*)\s*yards/);
        if (yardsMatch) {
          const battingYards = parseFloat(yardsMatch[1]);
          const costPerUnit = this.data.battingCostPerUnit || 5;
          totalCost += battingYards * costPerUnit;
        }
      } else if (batting?.sizeName && batting.sizeName.includes('meters')) {
        const metersMatch = batting.sizeName.match(/(\d+\.?\d*)\s*meters/);
        if (metersMatch) {
          const battingMeters = parseFloat(metersMatch[1]);
          const costPerUnit = this.data.battingCostPerUnit || 5;
          totalCost += battingMeters * costPerUnit;
        }
      }
    }

    // Binding fabric cost
    if (this.data.bindingType === 'pre-made' || this.data.preMadeBinding) {
      // Use custom price for pre-made binding
      const binding = this.calculateBinding(quiltSize);
      if (binding?.tapeNeeded) {
        const yardsMatch = binding.tapeNeeded.match(/(\d+\.?\d*)\s*yards/);
        if (yardsMatch) {
          const bindingYards = parseFloat(yardsMatch[1]);
          const pricePerYard = this.data.preMadeBindingPrice || 4; // Default $4/yd for pre-made binding
          totalCost += bindingYards * pricePerYard;
        }
      }
    } else {
      // Use regular fabric cost for self-made binding
      const binding = this.calculateBinding(quiltSize);
      if (binding?.fabric) {
        const bindingCutType = this.data.fabricCutType?.binding || 'off-the-bolt';
        if (bindingCutType === 'mini-charm' || bindingCutType === 'charm-pack' || bindingCutType === 'jelly-roll' || bindingCutType === 'layer-cake' || bindingCutType === 'fat-quarters' || bindingCutType === 'honey-bun') {
          // For packs, calculate proportional cost based on pieces used
          let piecesNeeded = 0;
          if (bindingCutType === 'jelly-roll' || bindingCutType === 'honey-bun') {
            const strips = binding.fabric.strips ? parseFloat(binding.fabric.strips) : 0;
            piecesNeeded = isNaN(strips) ? 0 : strips;
          } else {
            piecesNeeded = 1; // Conservative estimate for binding
          }
          const cost = this.calculateProportionalPackCost(bindingCutType, 'binding', piecesNeeded, costs.binding);
          if (!isNaN(cost)) totalCost += cost;
        } else {
          const bindingYards = parseFloat(binding.fabric.yards);
          if (!isNaN(bindingYards)) totalCost += bindingYards * costs.binding;
        }
      }
    }

    return Math.round(totalCost * 100) / 100; // Round to 2 decimal places
  }

  private formatFraction(decimal: number): string {
    const whole = Math.floor(decimal);
    const fraction = decimal - whole;
    
    if (fraction === 0) return whole.toString();
    
    // Convert common decimals to decimal format
    if (Math.abs(fraction - 0.125) < 0.001) return whole > 0 ? `${whole}.125` : '0.125';
    if (Math.abs(fraction - 0.25) < 0.001) return whole > 0 ? `${whole}.25` : '0.25';
    if (Math.abs(fraction - 0.375) < 0.001) return whole > 0 ? `${whole}.375` : '0.375';
    if (Math.abs(fraction - 0.5) < 0.001) return whole > 0 ? `${whole}.5` : '0.5';
    if (Math.abs(fraction - 0.625) < 0.001) return whole > 0 ? `${whole}.625` : '0.625';
    if (Math.abs(fraction - 0.75) < 0.001) return whole > 0 ? `${whole}.75` : '0.75';
    if (Math.abs(fraction - 0.875) < 0.001) return whole > 0 ? `${whole}.875` : '0.875';
    
    return decimal.toFixed(2);
  }

  private formatNumber(num: number): string {
    if (num <= 10) {
      const words = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten'];
      return words[num] || num.toString();
    }
    return num.toString();
  }

  private calculateSashing(blocksAcross: number, blocksDown: number, blockSize: { width: number; height: number }, sashingSize: number, seamAllowance: number) {
    if (sashingSize === 0) return undefined;

    const fabricWidth = this.data.fabricWidth?.sashing || 44;
    const hasCornerstone = this.data.cornerstones === true;
    
    // Unfinished sashing size (with seam allowance)
    const sashingWidth = sashingSize + (seamAllowance * 2);
    
    // Sashing columns: vertical strips between blocks in each row
    const columnsPerRow = blocksAcross - 1;
    const totalColumns = columnsPerRow * blocksDown;
    const columnSize = { width: sashingWidth, height: blockSize.height + (seamAllowance * 2) };
    
    // Sashing rows: horizontal strips between rows of blocks
    const totalRows = blocksDown - 1;
    let rowSize: { width: number; height: number };
    let rowStripsNeeded: number;
    let rowLength: number;
    
    if (hasCornerstone) {
      // With cornerstones: cut sashing into individual pieces between blocks
      const individualRowCount = totalRows * blocksAcross;
      rowSize = { 
        width: blockSize.width + (seamAllowance * 2), 
        height: sashingWidth 
      };
      const rowsPerStrip = Math.floor(fabricWidth / rowSize.width);
      rowStripsNeeded = Math.ceil(individualRowCount / rowsPerStrip);
      rowLength = rowStripsNeeded * rowSize.height;
    } else {
      // Without cornerstones: full-width strips
      rowSize = { 
        width: (blocksAcross * blockSize.width) + ((blocksAcross - 1) * sashingSize) + (seamAllowance * 2),
        height: sashingWidth
      };
      rowStripsNeeded = Math.ceil(totalRows);
      rowLength = rowStripsNeeded * rowSize.height;
    }
    
    // Calculate sashing fabric
    const columnsPerStrip = Math.floor(fabricWidth / columnSize.width);
    const columnStripsNeeded = Math.ceil(totalColumns / columnsPerStrip);
    const columnLength = columnStripsNeeded * columnSize.height;
    
    const totalSashingLength = columnLength + rowLength;
    const sashingYards = Math.ceil((totalSashingLength / 36) * 4) / 4;
    
    const useFatQuarters = this.data.fatQuarters?.sashing || false;
    const result: any = {
      fabric: {
        yards: this.formatFraction(sashingYards),
        meters: this.formatFraction(sashingYards * 0.9144),
        strips: this.formatNumber(columnStripsNeeded + rowStripsNeeded),
        stripWidth: this.formatFraction(sashingWidth),
      },
      rows: { 
        count: hasCornerstone ? totalRows * blocksAcross : totalRows, 
        size: rowSize 
      },
      columns: { count: totalColumns, size: columnSize },
      sewingOrder: hasCornerstone 
        ? [
            '1. Sew sashing columns to individual blocks',
            '2. Assemble rows of blocks', 
            '3. Sew sashing rows to cornerstones',
            '4. Assemble quilt: sew rows of blocks to rows of sashing'
          ]
        : [
            '1. Sew sashing columns to individual blocks',
            '2. Assemble rows of blocks',
            '3. Assemble quilt: sew rows of blocks to rows of sashing'
          ]
    };

    if (useFatQuarters) {
      const isMetric = this.data.measurementSystem === 'meters';
      const totalSashingPieces = totalColumns + (hasCornerstone ? totalRows * blocksAcross : totalRows);
      result.fabric.fatQuarters = this.calculateFatQuartersForSashing(totalSashingPieces, sashingWidth, isMetric).toString();
    }

    // Calculate packs for pre-cut fabrics
    const cutType = this.data.fabricCutType?.sashing;
    const elementMeasurement = this.data.measurementSystem === 'mix'
      ? (this.data.elementMeasurementSystem?.sashing || 'yards')
      : (this.data.measurementSystem || 'yards');
    const isMetric = elementMeasurement === 'meters';
    
    if (cutType && ['mini-charm', 'charm-pack', 'jelly-roll', 'layer-cake', 'fat-quarters', 'honey-bun'].includes(cutType)) {
      const totalSashingPieces = totalColumns + (hasCornerstone ? totalRows * blocksAcross : totalRows);
      result.fabric.packs = this.calculatePreCutPacks(
        'sashing',
        cutType,
        totalSashingPieces,
        columnSize.width,
        columnSize.height,
        columnStripsNeeded + rowStripsNeeded,
        isMetric
      );
    }

    // Handle cornerstone calculations and fat quarters
    if (hasCornerstone) {
      const cornerstoneCount = (blocksAcross - 1) * (blocksDown - 1);
      const cornerstoneSize = { width: sashingWidth, height: sashingWidth };
      const cornerstoneStripsNeeded = Math.ceil(cornerstoneCount / Math.floor(fabricWidth / cornerstoneSize.width));
      const cornerstoneYards = Math.ceil(((cornerstoneStripsNeeded * cornerstoneSize.height) / 36) * 4) / 4;
      
      result.cornerstone = {
        yards: this.formatFraction(cornerstoneYards),
        meters: this.formatFraction(cornerstoneYards * 0.9144),
        strips: this.formatNumber(cornerstoneStripsNeeded),
        stripWidth: this.formatFraction(cornerstoneSize.width),
      };
      result.cornerstones = { count: cornerstoneCount, size: cornerstoneSize };
      
      // Add fat quarters for cornerstones if selected
      const cornerstoneUseFatQuarters = this.data.fatQuarters?.cornerstones || false;
      if (cornerstoneUseFatQuarters) {
        const isMetric = this.data.measurementSystem === 'meters';
        result.cornerstone.fatQuarters = this.calculateFatQuartersForSashing(cornerstoneCount, sashingWidth, isMetric).toString();
      }

      // Calculate packs for cornerstone pre-cut fabrics
      const cornerstoneCutType = this.data.fabricCutType?.cornerstones;
      const cornerstoneElementMeasurement = this.data.measurementSystem === 'mix'
        ? (this.data.elementMeasurementSystem?.cornerstones || 'yards')
        : (this.data.measurementSystem || 'yards');
      const cornerstoneIsMetric = cornerstoneElementMeasurement === 'meters';
      
      if (cornerstoneCutType && ['mini-charm', 'charm-pack', 'jelly-roll', 'layer-cake', 'fat-quarters', 'honey-bun'].includes(cornerstoneCutType)) {
        result.cornerstone.packs = this.calculatePreCutPacks(
          'cornerstones',
          cornerstoneCutType,
          cornerstoneCount,
          cornerstoneSize.width,
          cornerstoneSize.height,
          cornerstoneStripsNeeded,
          cornerstoneIsMetric
        );
      }
    }

    return result;
  }

  private calculateMultipleBorders(quiltSize: { width: number; height: number }, totalBorderSize: number, seamAllowance: number) {
    if (!this.data.borders || totalBorderSize === 0) return undefined;

    const validBorders = this.data.borders.filter(border => border.size && border.size !== 'none');
    if (validBorders.length === 0) return undefined;

    const borders = [];
    let currentQuiltSize = { ...quiltSize };

    for (let i = 0; i < validBorders.length; i++) {
      const border = validBorders[i];
      const borderSize = border.size === 'custom' ? (border.customSize || 0) : parseFloat(border.size);
      
      if (borderSize > 0) {
        const borderResult = this.calculateSingleBorder(currentQuiltSize, borderSize, seamAllowance, i + 1);
        if (borderResult) {
          borders.push(borderResult);
          // Update quilt size for next border calculation
          currentQuiltSize = {
            width: currentQuiltSize.width + (borderSize * 2),
            height: currentQuiltSize.height + (borderSize * 2)
          };
        }
      }
    }

    return borders.length > 0 ? borders : undefined;
  }

  private calculateSingleBorder(quiltSize: { width: number; height: number }, borderSize: number, seamAllowance: number, borderNumber: number) {
    if (borderSize === 0) return undefined;

    const fabricWidth = this.data.fabricWidth?.border || 44;
    const borderWidth = borderSize + (seamAllowance * 2);
    
    // Calculate border dimensions (before adding this border)
    const innerWidth = quiltSize.width;
    const innerHeight = quiltSize.height;
    
    const columnSize = { width: borderWidth, height: innerHeight + (seamAllowance * 2) };
    const rowSize = { width: quiltSize.width + (borderSize * 2) + (seamAllowance * 2), height: borderWidth };
    
    // Calculate strips needed - cut from width of fabric
    // Top and bottom borders (cut along length of fabric)
    const topBottomLength = quiltSize.width + (seamAllowance * 2);
    const topBottomStripsNeeded = 2;
    
    // Left and right borders (cut along length of fabric) 
    const leftRightLength = innerHeight + (seamAllowance * 2);
    const leftRightStripsNeeded = 2;
    
    // Calculate yardage needed
    // Border requires 4 strips: 2 for top/bottom, 2 for left/right
    
    // Top and bottom strips: length = current quilt width + seam allowances
    const topBottomStripLength = quiltSize.width + (seamAllowance * 2);
    
    // Left and right strips: length = current quilt height + seam allowances
    const leftRightStripLength = innerHeight + (seamAllowance * 2);
    
    // Calculate total strip length needed
    const totalStripLength = (topBottomStripLength * 2) + (leftRightStripLength * 2);
    
    // Calculate how many strips needed from WOF
    const stripsNeeded = Math.ceil(totalStripLength / fabricWidth);
    
    let totalYards = 0;
    
    // Calculate fabric yardage needed
    // Each strip cut requires borderWidth inches of fabric length
    totalYards = (stripsNeeded * borderWidth) / 36;
    
    // Round up to nearest 0.25 yard
    const borderYards = Math.ceil(totalYards / 0.25) * 0.25;
    
    const useFatQuarters = this.data.fatQuarters?.border || false;
    
    const getOrdinal = (num: number) => {
      const ordinals = ["First", "Second", "Third", "Fourth", "Fifth", "Sixth"];
      return ordinals[num - 1] || `${num}th`;
    };

    const ordinal = getOrdinal(borderNumber);
    
    const result: any = {
      borderNumber,
      ordinal,
      fabric: {
        yards: this.formatFraction(borderYards),
        meters: this.formatFraction(borderYards * 0.9144),
        strips: this.formatNumber(stripsNeeded),
        stripWidth: this.formatFraction(borderWidth),
      },
      rows: { count: 2, size: rowSize },
      columns: { count: 2, size: columnSize },
      sewingOrder: [
        `1. Cut 2 strips for ${ordinal.toLowerCase()} border top and bottom`,
        `2. Cut 2 strips for ${ordinal.toLowerCase()} border left and right`, 
        `3. Sew ${ordinal.toLowerCase()} border top and bottom first`,
        `4. Sew ${ordinal.toLowerCase()} border left and right to complete`
      ]
    };

    if (useFatQuarters) {
      const isMetric = this.data.measurementSystem === 'meters';
      result.fabric.fatQuarters = this.calculateFatQuartersForBorder(quiltSize, borderSize, isMetric).toString();
    }

    // Calculate packs for pre-cut fabrics
    const borderElement = `border${borderNumber}`;
    const cutType = this.data.fabricCutType?.[borderElement as keyof typeof this.data.fabricCutType];
    const elementMeasurement = this.data.measurementSystem === 'mix'
      ? (this.data.elementMeasurementSystem?.[borderElement as keyof typeof this.data.elementMeasurementSystem] || 'yards')
      : (this.data.measurementSystem || 'yards');
    const isMetric = elementMeasurement === 'meters';
    
    if (cutType && ['mini-charm', 'charm-pack', 'jelly-roll', 'layer-cake', 'fat-quarters', 'honey-bun'].includes(cutType as string)) {
      // For borders, we have 4 pieces (2 rows + 2 columns)
      result.fabric.packs = this.calculatePreCutPacks(
        borderElement,
        cutType as string,
        4, // 2 top/bottom + 2 left/right
        borderWidth,
        Math.max(rowSize.width, columnSize.height),
        stripsNeeded,
        isMetric
      );
    }

    return result;
  }

  private calculateBorder(quiltSize: { width: number; height: number }, borderSize: number, seamAllowance: number) {
    // Legacy method for backward compatibility
    return this.calculateSingleBorder(quiltSize, borderSize, seamAllowance, 1);
  }

  private calculateBacking(quiltSize: { width: number; height: number }) {
    const fabricWidth = this.data.fabricWidth?.backing || 44;
    const backingWidth = quiltSize.width + 4; // Add 2" on each side  
    const backingHeight = quiltSize.height + 4; // Add 2" on each side
    
    // Calculate both orientations to find the most efficient
    
    // Option 1: Vertical panels (seams run horizontally)
    let verticalPanels = 1;
    let verticalPanelLength = backingHeight;
    let verticalTotalYards = backingHeight / 36;
    
    if (backingWidth > fabricWidth) {
      verticalPanels = Math.ceil(backingWidth / fabricWidth);
      verticalTotalYards = (verticalPanelLength * verticalPanels) / 36;
    }
    
    // Option 2: Horizontal panels (seams run vertically)
    let horizontalPanels = 1;
    let horizontalPanelLength = backingWidth;
    let horizontalTotalYards = backingWidth / 36;
    
    if (backingHeight > fabricWidth) {
      horizontalPanels = Math.ceil(backingHeight / fabricWidth);
      horizontalTotalYards = (horizontalPanelLength * horizontalPanels) / 36;
    }
    
    // Choose the most efficient option (uses less fabric)
    const useVertical = verticalTotalYards <= horizontalTotalYards;
    
    const panels = useVertical ? verticalPanels : horizontalPanels;
    const panelLength = useVertical ? verticalPanelLength : horizontalPanelLength;
    const totalYards = useVertical ? verticalTotalYards : horizontalTotalYards;
    const orientation = useVertical ? 'vertical' : 'horizontal';
    
    const finalYards = Math.ceil(totalYards * 4) / 4; // Round to nearest 0.25 yard
    
    const useFatQuarters = this.data.fatQuarters?.backing || false;
    
    const result: any = {
      fabric: {
        yards: this.formatFraction(finalYards),
        meters: this.formatFraction(finalYards * 0.9144),
        panels: this.formatNumber(panels),
        panelLength: this.formatFraction(panelLength),
        orientation: orientation === 'vertical' ? 'Vertical panels (seams run horizontally)' : 'Horizontal panels (seams run vertically)'
      },
      size: { width: backingWidth, height: backingHeight }
    };

    if (useFatQuarters) {
      const isMetric = this.data.measurementSystem === 'meters';
      result.fabric.fatQuarters = this.calculateFatQuartersForBacking(quiltSize, isMetric).toString();
    }

    // Calculate packs for pre-cut fabrics
    const cutType = this.data.fabricCutType?.backing;
    const elementMeasurement = this.data.measurementSystem === 'mix'
      ? (this.data.elementMeasurementSystem?.backing || 'yards')
      : (this.data.measurementSystem || 'yards');
    const isMetric = elementMeasurement === 'meters';
    
    if (cutType && ['mini-charm', 'charm-pack', 'jelly-roll', 'layer-cake', 'fat-quarters', 'honey-bun'].includes(cutType)) {
      // For backing, calculate based on the backing dimensions
      result.fabric.packs = this.calculatePreCutPacks(
        'backing',
        cutType,
        panels, // number of pieces
        backingWidth,
        backingHeight,
        panels,
        isMetric
      );
    }

    return result;
  }

  private calculateBatting(quiltSize: { width: number; height: number }) {
    // Check if user selected off-the-bolt batting
    if (this.data.battingType === 'off-the-bolt') {
      const isMetric = this.data.measurementSystem === 'meters';
      const battingWidth = quiltSize.width + 2; // Add 1" on each side  
      const battingHeight = quiltSize.height + 2; // Add 1" on each side
      
      // Get batting width from user input
      let userBattingWidth = 90; // default
      if (this.data.battingWidth === 'custom') {
        userBattingWidth = this.data.customBattingWidth || 90;
      } else {
        userBattingWidth = parseFloat(this.data.battingWidth || '90');
      }
      
      // Convert batting width to inches if needed (assume user input is in inches, which is standard)
      const battingWidthInches = userBattingWidth;
      
      // Calculate how much batting needed
      let battingLength;
      if (battingWidthInches >= battingWidth) {
        // Can fit width-wise, use height
        battingLength = battingHeight;
      } else {
        // Need to piece or use more length
        battingLength = battingWidth; // Use the longer dimension
      }
      
      // Convert to yards/meters
      const battingNeeded = isMetric 
        ? battingLength / 39.37 // Convert inches to meters
        : battingLength / 36; // Convert inches to yards
      
      // Format the result
      const formattedAmount = isMetric 
        ? this.formatFraction(battingNeeded) + ' meters'
        : this.formatFraction(battingNeeded) + ' yards';
      
      return {
        sizeName: formattedAmount,
        link: '',
        multiple: false,
        offTheBolt: true
      };
    }
    
    // Original pre-cut batting logic
    const battingWidth = quiltSize.width + 2; // Add 1" on each side  
    const battingHeight = quiltSize.height + 2; // Add 1" on each side
    
    // Find the smallest batting size that fits (allowing rotation)
    for (const batting of BATTING_SIZES) {
      // Check if batting fits in original orientation or rotated 90 degrees
      const fitsOriginal = batting.width >= battingWidth && batting.height >= battingHeight;
      const fitsRotated = batting.height >= battingWidth && batting.width >= battingHeight;
      
      if (fitsOriginal || fitsRotated) {
        return {
          sizeName: batting.name,
          link: batting.link,
          multiple: false,
          offTheBolt: false
        };
      }
    }
    
    // If no single batting fits, use the largest
    const largest = BATTING_SIZES[BATTING_SIZES.length - 1];
    return {
      sizeName: largest.name,
      link: largest.link,
      multiple: true,
      offTheBolt: false
    };
  }

  private calculateBinding(quiltSize: { width: number; height: number }) {
    const isPreMade = this.data.bindingType === 'pre-made' || this.data.preMadeBinding === true;
    const bindingWidth = this.data.bindingWidth === 'custom' 
      ? (this.data.customBindingWidth || 2.5)
      : parseFloat(this.data.bindingWidth || '2.5');
    
    // Calculate perimeter plus extra for corners and joining
    const perimeter = (quiltSize.width + quiltSize.height) * 2;
    const totalLength = perimeter + 12; // Add 12" for corners and joining
    
    if (isPreMade) {
      return {
        tapeNeeded: `${totalLength}" or ${this.formatFraction(totalLength / 36)} yards`
      };
    }
    
    const fabricWidth = this.data.fabricWidth?.binding || 44;
    const stripWidth = bindingWidth; // No seam allowance for user-cut binding
    
    // Calculate bias strips needed
    const stripLength = fabricWidth - 2; // Account for bias cutting
    const stripsNeeded = Math.ceil(totalLength / stripLength);
    const fabricNeeded = (stripsNeeded * stripWidth) / 36;
    const yards = Math.ceil(fabricNeeded * 4) / 4;
    
    const useFatQuarters = this.data.fatQuarters?.binding || false;
    const cutType = this.data.fabricCutType?.binding || 'off-the-bolt';
    
    const result: any = {
      fabric: {
        yards: this.formatFraction(yards),
        meters: this.formatFraction(yards * 0.9144),
        strips: this.formatNumber(stripsNeeded),
        stripWidth: this.formatFraction(stripWidth),
      },
      size: { length: totalLength }
    };

    if (useFatQuarters) {
      const isMetric = this.data.measurementSystem === 'meters';
      result.fabric.fatQuarters = this.calculateFatQuartersForBinding(quiltSize, bindingWidth, isMetric).toString();
    }

    // Calculate packs for precut fabrics
    const elementMeasurement = this.data.measurementSystem === 'mix'
      ? (this.data.elementMeasurementSystem?.binding || 'yards')
      : (this.data.measurementSystem || 'yards');
    const isMetric = elementMeasurement === 'meters';
    
    if (['mini-charm', 'charm-pack', 'jelly-roll', 'layer-cake', 'fat-quarters', 'honey-bun'].includes(cutType)) {
      // For binding, we need strips, so calculate based on that
      result.fabric.packs = this.calculatePreCutPacks(
        'binding',
        cutType,
        stripsNeeded, // Use stripsNeeded as totalPieces for binding
        stripWidth,
        stripLength,
        stripsNeeded,
        isMetric
      );
    }

    return result;
  }
}